export const AVATAR_FORMATS = [
    "image/gif",
    "image/jpeg",
    "image/png"
] 